import {
  VectorStyleLayer,
  VectorStyle
} from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';

const GOV_SIGMETS_PAINT = {
  ICING: {
    'fill-color': '#0078B7',
    'fill-outline-color': '#0078B7',
    'fill-opacity': 0.2
  },
  ICING_OUTLINE: {
    'line-width': 1.3,
    'line-color': '#0078B7'
  },
  TURB: {
    'fill-color': '#FF7200',
    'fill-outline-color': '#FF7200',
    'fill-opacity': 0.2
  },
  TURB_OUTLINE: {
    'line-width': 1.3,
    'line-color': '#FF7200'
  },
  CONV: {
    'fill-color': '#C90015',
    'fill-outline-color': '#C90015',
    'fill-opacity': 0.1
  },
  CONV_OUTLINE: {
    'line-width': 1.3,
    'line-color': '#C90015'
  },
  MOUNTAIN: {
    'fill-color': '#FF00FF',
    'fill-outline-color': '#FF00FF',
    'fill-opacity': 0.2
  },
  MOUNTAIN_OUTLINE: {
    'line-width': 1.3,
    'line-color': '#FF00FF'
  },
  VA: {
    'fill-color': '#F6F6F6',
    'fill-outline-color': '#C90015',
    'fill-opacity': 0.3
  },
  VA_OUTLINE: {
    'line-width': 1.3,
    'line-color': '#C90015'
  },
  DUST_SAND: {
    'fill-color': '#FCC911',
    'fill-outline-color': '#C39B08',
    'fill-opacity': 0.2
  },
  DUST_SAND_OUTLINE: {
    'line-width': 1.3,
    'line-color': '#C39B08'
  },
  RADIOACTIVE: {
    'fill-color': '#42FF00',
    'fill-outline-color': '#42FF00',
    'fill-opacity': 0.1
  },
  RADIOACTIVE_OUTLINE: {
    'line-width': 1.3,
    'line-color': '#42FF00'
  }
};

const TWC_GOVERNMENT_SIGMETS_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.ICING,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ice',
    filter: ['==', 'type', 'ICE'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.TURB,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'turb',
    filter: ['==', 'type', 'TURB'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.CONV,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'conv',
    filter: ['==', 'phenomenon', 'CONV'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.CONV,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ts',
    filter: ['==', 'type', 'TS'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.CONV,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'tc',
    filter: ['==', 'type', 'TC'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.MOUNTAIN,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'mtw',
    filter: ['==', 'type', 'MTW'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.VA,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'va',
    filter: ['==', 'type', 'VA'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.VA,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'va-cld',
    filter: ['==', 'type', 'VA CLD'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.DUST_SAND,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ds',
    filter: ['==', 'type', 'DS'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.DUST_SAND,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ss',
    filter: ['==', 'type', 'SS'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.RADIOACTIVE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'rdoact-cld',
    filter: ['==', 'type', 'RDOACT CLD'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.ICING_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ice-2',
    filter: ['==', 'type', 'ICE'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.TURB_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'turb-2',
    filter: ['==', 'type', 'TURB'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.CONV_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'conv-2',
    filter: ['==', 'phenomenon', 'CONV'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.CONV_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ts-2',
    filter: ['==', 'type', 'TS'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.CONV_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'tc-2',
    filter: ['==', 'type', 'TC'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.MOUNTAIN_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'mtw-2',
    filter: ['==', 'type', 'MTW'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.VA_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'va-2',
    filter: ['==', 'type', 'VA'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.VA_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'va-cld-2',
    filter: ['==', 'type', 'VA CLD'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.DUST_SAND_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ds-2',
    filter: ['==', 'type', 'DS'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.DUST_SAND_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ss-2',
    filter: ['==', 'type', 'SS'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: GOV_SIGMETS_PAINT.RADIOACTIVE_OUTLINE,
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'rdoact-cld-2',
    filter: ['==', 'type', 'RDOACT CLD'],
    type: 'line',
    maxzoom: 28
  }
];

export const TWC_GOVERNMENT_SIGMETS_VECTOR_STYLE: VectorStyle = {
  layers: TWC_GOVERNMENT_SIGMETS_VECTOR_STYLE_LAYERS
};
